import { BlueprintMarkdown } from '@/components/BlueprintMarkdown';
import { ScorecardRichText } from '@/components/scorecard/ScorecardRichText';

export type StoryOverviewStructured = {
  script_title?: string | null;
  genre?: string | null;
  lead_character?: string | null;
  logline?: string | null;
  synopsis?: string | null;
  comparable_films?: string | null;
};

type StoryOverviewSectionProps = {
  markdown: string;
  structured?: StoryOverviewStructured | null;
};

function FieldRow({ label, value }: { label: string; value?: string | null }) {
  const display = value?.trim() || '—';
  return (
    <div className="mb-4">
      <p className="text-[10px] font-mono uppercase tracking-[0.2em] text-white/45 mb-1">{label}</p>
      <ScorecardRichText text={display} className="space-y-0 text-sm leading-relaxed text-white/85" />
    </div>
  );
}

function parseSynopsisFromMarkdown(markdown: string): string {
  const m = markdown.match(/\*\*Synopsis\*\*\s*\n+([\s\S]*?)(?=\n\s*\*\*[A-Z]|\n---|\Z)/i);
  return m?.[1]?.trim() ?? '';
}

export function StoryOverviewSection({ markdown, structured }: StoryOverviewSectionProps) {
  const synopsis =
    structured?.synopsis?.trim() ||
    (structured?.script_title ? parseSynopsisFromMarkdown(markdown) : '');

  if (structured?.script_title || synopsis) {
    return (
      <div className="space-y-1">
        <FieldRow label="Title" value={structured?.script_title} />
        <FieldRow label="Genre" value={structured?.genre} />
        <FieldRow label="Lead character" value={structured?.lead_character} />
        <FieldRow label="Logline" value={structured?.logline} />
        <FieldRow label="Comparable films" value={structured?.comparable_films} />
        {synopsis ? (
          <div className="mt-6 pt-4 border-t border-[#2a2a2a]">
            <p className="text-[10px] font-mono uppercase tracking-[0.2em] text-white/45 mb-3">
              Synopsis
            </p>
            <ScorecardRichText text={synopsis} />
          </div>
        ) : null}
      </div>
    );
  }

  return (
    <div className="[&_.blueprint-markdown]:text-white/85">
      <BlueprintMarkdown markdown={markdown} />
    </div>
  );
}

export default StoryOverviewSection;
